import React from 'react';
import { Formik } from 'formik';

import { ModalWrapper } from './styles';
import { itemText } from '$gbusiness/helpers/util';
import { input } from '$gbusiness/helpers';
import Footer from '$gcomponents/widgets/footer';

import { FormSection } from '$gcomponents/reusables';
import { PageWrapper } from '$gstyles/wrapper';
import { ORDER_DELIVERY_FORM } from './orderUpdateForm';
import { useSelector } from 'react-redux';
import { IonContent } from '@ionic/react';
import { Button } from '$gcomponents/primitives';
import intl from '$gintl';
import { ORDER_STATUS } from '$fbusiness/enums/options/orderStatus';

interface OrderUpdateModalProps {
  orderId: number;
  onSubmitDelivery: Function;
  onClose: () => void;
}

const OrderDeliveryModal: React.FC<OrderUpdateModalProps> = ({ orderId, onClose, onSubmitDelivery }) => {
  const factory = useSelector((state: any) => state.factory.factory);
  const { users } = factory;

  const onSubmit = (values) => {
    if (!orderId) return;
    onSubmitDelivery({ ...values, id: orderId, status: ORDER_STATUS.DELIVERED });
  };

  const orderForm = ORDER_DELIVERY_FORM({ users });

  const validateForm = (values) => {
    return input.validateError(orderForm, values);
  };

  return (
    <ModalWrapper
      titleText={itemText('EDIT', 'Delivery Details')}
      show={!!orderId}
      width="400px"
      height="300px"
      onClose={() => onClose()}
      useCustom>
      <Formik
        enableReinitialize={true}
        initialValues={{
          deliveredDate: new Date(),
        }}
        validate={validateForm}
        onSubmit={(values) => {
          onSubmit(values);
        }}>
        {(formik) => (
          <>
            <IonContent>
              <PageWrapper>
                <FormSection FORM={orderForm} formik={formik} />
              </PageWrapper>
            </IonContent>
            <Footer>
              <Button onClick={onClose} variant="outlined">
                {intl('BUTTON.CANCEL')}
              </Button>
              <Button onClick={formik.submitForm}>{intl('BUTTON.UPDATE')}</Button>
            </Footer>
          </>
        )}
      </Formik>
    </ModalWrapper>
  );
};

export default OrderDeliveryModal;
